import React, { useEffect } from "react";
import "../styles/Camps.css"; // optional if you want to move styles separately
import { useNavigate } from "react-router-dom";

const Camps = () => {
  const navigate = useNavigate();
  const handleClick = () => {
   navigate("/contact"); // redirects to Contact page
  };
useEffect(() => {
  let slideIndex = 0;
  let timer;

  const showSlides = () => {
    const slides = document.querySelectorAll(".slide");

    if (slides.length === 0) return; // Prevent error if no slides

    slides.forEach((slide) => (slide.style.display = "none"));
    slideIndex++;

    if (slideIndex > slides.length) slideIndex = 1;

    slides[slideIndex - 1].style.display = "block";

    timer = setTimeout(showSlides, 3000);
  };

  showSlides();

  return () => {
    clearTimeout(timer); // STOP slideshow when leaving page
  };
}, []);

function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(
  require.context("../assets/slideshow", false, /\.(png|jpe?g|svg)$/)
);

  return (
    <>
      {/* ✅ HERO SECTION */}
      <section className="hero">
        <h2>Upcoming Donation Camps</h2>
        <p>
          Join our community camps — give a small gift that can change lives.
        </p>
      </section>

      {/* ✅ MAIN CONTAINER */}
      <main className="container">
        <h2 className="section-title">Blood Donation Camp Gallery</h2>
        <p className="section-desc">
          Glimpses from our recent blood donation camps.
        </p>

        {/* ✅ SLIDESHOW */}
  <div className="slideshow-container">
  {images.map((image, index) => (
    <div key={index} className="slide fade">
      <img src={image} alt={`Slide ${index}`} />
    </div>
  ))}
</div>

      </main>

      {/* ✅ ORGANIZER REQUIREMENTS */}
      <section className="container" id="camp-requirements">
        <h2 className="section-title">Organize a Blood Donation Camp</h2>
        <p className="section-desc">
          Planning to host a blood donation drive at your organization, college,
          or community hall? Here’s a simple guide to ensure the camp runs
          smoothly and safely.
        </p>

        <div className="requirements-box"style={{
  background: "#fdf3f3",
  borderRadius: "12px",
  padding: "1.2rem 1.6rem",
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
}}>
          <h3>Venue & Environment</h3>
          <ul>
            <li>Organize the camp in a clean, enclosed hall with tiled floor.</li>
            <li>Ensure good ventilation, lighting, and cleanliness.</li>
            <li>Provide fans or A/C for donor comfort.</li>
          </ul>

          <h3>Medical & Donor Facilities</h3>
          <ul>
            <li>Provide a room for check-up and registration.</li>
            <li>Ensure drinking water and hand washing facilities.</li>
            <li>Maintain continuous power supply for instruments.</li>
          </ul>
          <h3>Blood Donor Eligibility</h3>
          <ul>
                  <li>✔ Age 18–65 years</li>
                  <li>✔ Minimum weight 50 kg</li>
                  <li>✔ Hemoglobin 12.5 g/dL or above</li>
                  <li>✔ No major illness in last 6 months</li>
                  <li>✔ No alcohol in last 24 hours</li>
                  <li>✔ No recent surgery or infection</li>
          </ul>

          <h3>Checklist Before Donation</h3>
          <ul>
                  <li>Slept at least 6 hours last night</li>
                  <li>Had a proper meal before donation</li>
                  <li>No cold, fever, or infection</li>
                  <li>Well hydrated</li>
          </ul>









          <h3>Furniture & Equipment</h3>
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th style={{ textAlign: "center" }}>Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Registration Table</td><td style={{ textAlign: "center" }}>1</td></tr>
              <tr><td>Hb & Blood Grouping Table</td><td style={{ textAlign: "center" }}>1</td></tr>
              <tr><td>Blood Bag Preparation Table</td><td style={{ textAlign: "center" }}>1</td></tr>
              <tr><td>Refreshment Table</td><td style={{ textAlign: "center" }}>1</td></tr>
              <tr><td>Certificate Writing Table</td><td style={{ textAlign: "center" }}>1</td></tr>
              <tr><td>Donation Area Table</td><td style={{ textAlign: "center" }}>1</td></tr>
              <tr style={{ background: "#fff5f5", fontWeight: "600" }}>
                <td>Total Tables</td><td style={{ textAlign: "center" }}>6</td>
              </tr>
              <tr><td>Chairs</td><td style={{ textAlign: "center" }}>20</td></tr>
              <tr><td>Dustbins</td><td style={{ textAlign: "center" }}>2</td></tr>
            </tbody>
          </table>

          <h3>Additional Tips</h3>
          <ul>
            <li>Use clean carpets in the donor area.</li>
            <li>Keep sanitizers, gloves, and first-aid kits available.</li>
            <li>Display banners promoting voluntary donation.</li>
          </ul>

          <p style={{ textAlign: "center", marginTop: "2rem" }}>
            <button
              className="btn"
              onClick={handleClick}>
              Request to Organize a Camp
            </button>
          </p>
        </div>
      </section>
    </>
  );
};

export default Camps;
